import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function DonutChartIcon(props: ACIconProps) {
  return <ACIconWrapper component={IconSvg} {...props} />;
}

const IconSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="1em"
      viewBox="0 0 36 36"
      fill="none"
    >
      <path
        d="M18 7C19.6928 7 21.3648 7.37372 22.8965 8.09449C24.4282 8.81525 25.7819 9.86529 26.8609 11.1696C27.9399 12.474 28.7177 14.0004 29.1387 15.6401C29.5597 17.2797 29.6135 18.9921 29.2963 20.6549"
        stroke="#927BF0"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M27.4202 25.0961C26.4143 26.5328 25.0931 27.7203 23.5577 28.5678C22.0224 29.4154 20.3135 29.9006 18.5618 29.9863C16.8101 30.0719 15.062 29.7558 13.4512 29.0621C11.8405 28.3684 10.4097 27.3155 9.26838 25.9839"
        stroke="#CCBFFF"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M7.19354 22.4332C6.61456 20.8425 6.39391 19.1436 6.54733 17.4577C6.70075 15.7719 7.22447 14.1407 8.08109 12.6806"
        stroke="#927BF0"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M11.4039 9.07975C12.1941 8.52643 13.0508 8.07473 13.9538 7.73531"
        stroke="#CCBFFF"
        strokeWidth="3"
        strokeLinecap="round"
      />
    </svg>
  );
};
